<color-twitter
    *ngIf="isVisible && !usesPanel"
    [triangle]="false"
    disableAlpha="true"
    [color]="selectedColor"
    [colors]="colors"
    class="cpicker"
    style="position: absolute; left: 0;"
    (onChangeComplete)="onColorChanged($event)">
</color-twitter>

<!-- Painel de escolha (ORCA-1884; web desde a ORCA-1895): folha inferior no mobile,
     popover junto da amostra na web. Prévia ao vivo; a cor só é gravada em "Aplicar" -->
<div *ngIf="isVisible && usesPanel" #panel class="cpicker-sheet" [class.cpicker-sheet--popover]="!isTouch"
    [style.top.px]="!isTouch ? popoverTop : null" [style.left.px]="!isTouch ? popoverLeft : null"
    [style.visibility]="!isTouch && !popoverReady ? 'hidden' : null"
    role="dialog" aria-modal="true" [attr.aria-label]="'Escolher cor: ' + label" (click)="$event.stopPropagation()">
    <div class="cpicker-sheet-header">
        <span class="cpicker-sheet-swatch" [style.background-color]="draftColor"></span>
        <span class="cpicker-sheet-title">{{ label }}</span>
        <button type="button" class="oa-icon-btn" (click)="cancelDraft($event)" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <color-sketch disableAlpha="true" [color]="draftColor" [presetColors]="panelPresetColors" width="auto"
        class="cpicker-touch" (onChange)="onDraftChanged($event)"></color-sketch>

    <div class="cpicker-sheet-actions">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="cancelDraft($event)">Cancelar</button>
        <button type="button" class="oa-btn oa-btn--primary" (click)="applyDraft($event)">Aplicar</button>
    </div>
</div>

<div *ngIf="isVisible" class="overlay" [class.overlay-touch]="usesPanel" [class.overlay-clear]="usesPanel && !isTouch"
    (click)="overlayClick($event)"></div>
